import { LodgingAddress, LodgingAddressEnum } from "@b2bportal/lodging-api";
import { ensureExhaustive } from "../common";

export const getAddressText = (address: LodgingAddress): string | null => {
  switch (address.LodgingAddress) {
    case LodgingAddressEnum.Exact:
      return address.line1;
    case LodgingAddressEnum.Obfuscated:
      return address.city;
    default:
      return ensureExhaustive(address);
  }
};
